import { setTagContext } from "./logContext.js";

//#region src/browserShim.ts
/**
* Initialize browser-specific shims for greenhouse.
* Call this early in portal boot before any logging occurs.
*/
function initBrowser() {
	let store;
	setTagContext({
		getStore: () => store,
		run: (tags, fn) => {
			const prev = store;
			store = tags;
			try {
				return fn();
			} finally {
				store = prev;
			}
		}
	});
}

//#endregion
export { initBrowser };
//# sourceMappingURL=browserShim.js.map